(() => {
  const dialog = document.getElementById('NlxWhatsAppDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const floating = document.querySelector('.nlx-wa-trigger--floating');
  let origin = null;
  let frame = 0;
  const visible = (element) => {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
  };
  const placeFloating = () => {
    frame = 0;
    if (!floating) return;
    const overlays = [...document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__banner__dialog, .shopify-pc__prefs__dialog, cart-drawer.active')];
    const blocked = overlays.some(visible);
    if (floating.hidden !== blocked) floating.hidden = blocked;
    if (blocked) return;
    let bottom = matchMedia('(max-width: 749px)').matches ? 16 : 24;
    const previewBar = document.getElementById('PBarNextFrame');
    if (previewBar && visible(previewBar)) bottom = Math.max(bottom, 80);
    const candidates = document.querySelectorAll('[class*="sticky"], [data-sticky-add-to-cart], #preview-bar-iframe');
    for (const element of candidates) {
      if (element === floating || !visible(element)) continue;
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      if (['fixed', 'sticky'].includes(style.position) && rect.width > innerWidth * 0.65 && rect.height < 180 && rect.bottom >= innerHeight - 2 && rect.top > innerHeight / 2) {
        bottom = Math.max(bottom, innerHeight - rect.top + 16);
      }
    }
    const value = `${Math.ceil(bottom)}px`;
    if (floating.style.getPropertyValue('--nlx-wa-bottom') !== value) floating.style.setProperty('--nlx-wa-bottom', value);
  };
  const schedulePlacement = () => {
    if (!frame) frame = requestAnimationFrame(placeFloating);
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-nlx-whatsapp-trigger]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    origin = trigger;
    if (!dialog.open) dialog.showModal();
    placeFloating();
  });
  dialog.querySelector('[data-nlx-whatsapp-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    placeFloating();
    origin?.focus({ preventScroll: true });
  });
  dialog.querySelector('[data-nlx-whatsapp-alternative]')?.addEventListener('click', (event) => {
    const form = document.getElementById('ContactForm');
    if (!form || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    origin = null;
    dialog.close();
    form.scrollIntoView({ behavior: 'auto', block: 'start' });
    form.querySelector('input:not([type="hidden"]), textarea, button')?.focus({ preventScroll: true });
  });
  addEventListener('scroll', schedulePlacement, { passive: true });
  addEventListener('resize', schedulePlacement, { passive: true });
  new MutationObserver(schedulePlacement).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'style', 'hidden', 'aria-hidden', 'aria-modal'] });
  placeFloating();
})();
